export const CAMPAIGN_USERS_API_PATH = "campaign-users"

export const CAMPAIGN_USERS_PATHS = {
	GET_CAMPAIGN_USERS_LIST: "/list",
	GET_PAGINATED_CAMPAIGN_USERS: "/paginated",
};